import { useEffect } from "react";

// #867 — per-route browser tab title. Several routes can be open in separate
// tabs (a ride, a class, the review queue…) and index.html's static
// "Score Admin | Fox Village" made every one of them indistinguishable.
// Callers pass the fully-formed, already-translated title string (including
// the "| Score Admin" suffix, see locales/en/scoreadmin.json's `title.*`
// keys) — this hook just applies it and restores whatever title was set
// before it, so unmounting (or a parent route re-rendering) never leaves a
// stale title behind.
export function useDocumentTitle(title) {
  useEffect(() => {
    if (!title) return undefined;
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
